import { SimpleGrid, Heading, Box, Flex, Spacer, Text } from '@chakra-ui/react';
import React from 'react';

import {
  date as commonDate,
  utils as commonUtils,
} from '@finley-technologies/common';

import { CoreBorrowingBaseInsightsGqlDataGQLType } from 'types/dashboard-core-gqlTypes.generated';

import { PortfolioGridItem } from '../shared/PortfolioTemplate';
import { PortfolioSummaryBorrowingBaseSummary } from './PortfolioSummaryBorrowingBaseSummary';

type PortfolioSummaryChartCardsProps = {
  selectedBarData: CoreBorrowingBaseInsightsGqlDataGQLType;
  creditFacilityId: string;
};
export const PortfolioSummaryChartCards = ({
  selectedBarData,
  creditFacilityId,
}: PortfolioSummaryChartCardsProps) => {
  const {
    reportingDate,
    fileVersion,
    currentPrincipalBalance,
    commitmentAmount,
    totalFacilityUtilization,
  } = selectedBarData;
  return (
    <Box>
      <Flex>
        <Heading as="h3" size="md" mb="24px">
          Utilization
        </Heading>
        <Spacer />
        <Text fontSize="sm" fontWeight={500}>
          Reporting Date:{' '}
          {commonDate.fullDateStrToHumanDateString(reportingDate)}
        </Text>
      </Flex>
      <SimpleGrid
        columns={{
          sm: 1,
          md: 2,
          lg: 3,
          xl: 3,
        }}
        spacingX="24px"
        spacingY="24px"
      >
        <PortfolioGridItem
          label="Principal Balance"
          value={commonUtils.numberToCurrencyWithSymbol({
            number: currentPrincipalBalance,
          })}
        />
        <PortfolioGridItem
          label="Commitment"
          value={commonUtils.numberToCurrencyWithSymbol({
            number: commitmentAmount,
          })}
        />
        <PortfolioGridItem
          label="Total Facility Utilization"
          value={
            totalFacilityUtilization
              ? commonUtils.numberToFormattedString(
                  totalFacilityUtilization,
                  'percentage',
                  false,
                )
              : '-'
          }
        />
      </SimpleGrid>

      <PortfolioSummaryBorrowingBaseSummary
        creditFacilityId={creditFacilityId}
        reportingDate={reportingDate}
        fileVersion={fileVersion}
      />
    </Box>
  );
};
